import './bootstrap';
import * as bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import DataTable from 'datatables.net-dt';


import '../landing/css/bootstrap.css';
import '../css/dark-style.css';
import '../css/skin-modes.css';
import '../css/color1.css';
import '../css/style.css';

// import '../css/iconfonts/bootstrapicons/bootstrap-icons.css';
// import '../css/iconfonts/font-awesome/css/font-awesome.min.css';
// import '../css/iconfonts/glyphicons/glyphicon.css';
// import '../css/iconfonts/linearicons/Linearicons.css';
import '../css/iconfonts/materialdesignicons/materialdesignicons.css';
// import '../css/iconfonts/pe-icon-7-stroke/Pe-icon-7.css';
// import '../css/iconfonts/simple-line-icons/simple-line-icons.css';
// import '../css/iconfonts/themify/themify.css';
// import '../css/iconfonts/typicons/typicons.css';
// import '../css/iconfonts/weathericons/weathericons.css';
// import '../css/iconfonts/feather/feather.css';
// import '../css/iconfonts/remixicon/remixicon.css';

import '../app/app.js';
import '../app/sticky.js';
import '../app/sidemenu.js';
import '../app/plugins/select2/select2.full.min.js';
import '../landing/js/plugins.init.js';
import '../landing/js/bootstrap.bundle.min.js';


import '../app/plugins/formwizard/jquery.smartWizard.js';
import '../app/plugins/formwizard/formwizard.js';
import '../app/plugins/jquery-steps/jquery.steps.min.js';
import '../app/plugins/accordion-Wizard-Form/jquery.accordion-wizard.min.js';
import '../app/plugins/formwizard/jquery.smartWizard.js';
import '../app/form-wizard.js';

import Chart from 'chart.js/auto';

window.Chart = Chart;

import moment from 'moment';
window.moment = moment;

import Swal from 'sweetalert2';
window.Swal = Swal;

import A from 'aladin-lite';
window.A = A;

window.nrt_channels = [
  // Fold Mirror
  'nrt.ag.m3.M3RotationPosition',
  'nrt.ag.m3.fbM3RotationAxisEn.OutputValue',
  'nrt.ag.m3.eM3RotationAxisState',
  'nrt.ag.m3.LinearPosition',
  'nrt.ag.m3.fbLinearAxisEn.OutputValue',
  'nrt.ag.m3.eLinearAxisState',
  'nrt.ag.m3.LinearBrakeStatus',
  'nrt.ag.m3.Estop',
  'nrt.ag.m3.UPSStatus.ePowerStatus',
  'nrt.ag.m3.fbAGPowerStatus.MotorPowerV',
  'nrt.ag.m3.fbAGPowerStatus.AGPowerV',
  'nrt.ag.m3.AirPressure',
  'nrt.ag.m3.TelescopeMode',
  // weather channels
  'cmt.monitoring.weatherstation.wind_direction_min',
  'cmt.monitoring.weatherstation.wind_direction_avg',
  'cmt.monitoring.weatherstation.wind_direction_max',
  'cmt.monitoring.weatherstation.wind_speed_min',
  'cmt.monitoring.weatherstation.wind_speed_max',
  'cmt.monitoring.weatherstation.air_temperature',
  'cmt.monitoring.weatherstation.relative_humidity',
  'cmt.monitoring.weatherstation.air_pressure',
  'cmt.monitoring.weatherstation.rain_accumulation',
  'cmt.monitoring.weatherstation.rain_duration',
  'cmt.monitoring.weatherstation.rain_intensity',
  'cmt.monitoring.weatherstation.hail_accumulation',
  'cmt.monitoring.weatherstation.hail_duration',
  'cmt.monitoring.weatherstation.hail_peak_intensity',
  'cmt.monitoring.weatherstation.heating_temperature',
  'cmt.monitoring.weatherstation.heating_voltage',
  'cmt.monitoring.weatherstation.supply_voltage',
  'cmt.monitoring.weatherstation.reference_voltage',
];

window.sodc_channels = [
  'users',
  'web-logs',
  'api-logs',
  'model-logs',
  'telemetry-logs'
];

window.callErrorToast = function (a, b, c) {
  Swal.fire({
    toast: true,
    position: 'bottom-end',
    icon: 'error',
    title: a,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
};

window.callSuccessToast = function (a, b, c) {
  Swal.fire({
    toast: true,
    position: 'bottom-end',
    icon: 'success',
    title: a,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
};
window.addEventListener('DOMContentLoaded', () => {
  // 1) find every <table class="basic-datatable">
  const tables = Array.from(document.querySelectorAll('table.basic-datatable'));
  if (!tables.length) return;

  // 2) initialize one DataTable per element
  const instances = tables.map(el => {
    return new DataTable(el, {
      paging: true,
      searching: true,
      pageLength: 50,
      ordering: true,
      info: true,
      stateSave: true,
      layout: {
        topStart: 'pageLength',
        topEnd: 'search',
        bottomStart: 'info',
        bottomEnd: 'paging'
      },
      responsive: true,
      scrollX: true,
      autoWidth: false
    });
  });

  // helper to force a redraw & column‐adjust on every instance
  const recalc = () => {
    instances.forEach(dt => dt.columns.adjust().responsive.recalc());
  };

  // 3) initial Select2 init on all selects
  $('.select2').each(function () {
    $(this).select2({
      width: 'resolve',
      placeholder: $(this).data('placeholder')
    });
  });

  // 4) re-init Select2 whenever any table redraws (paging, filter, sort)
  instances.forEach(dt => {
    dt.on('draw', () => {
      $('.select2').each(function () {
        // destroy old instance if present
        if ($(this).hasClass('select2-hidden-accessible')) {
          $(this).select2('destroy');
        }
        // re-initialize
        $(this).select2({
          width: 'resolve',
          placeholder: $(this).data('placeholder')
        });
      });
      // and re-adjust columns
      recalc();
    });
  });

  // 5) on window resize
  window.addEventListener('resize', recalc);

  // 6) when any BS5 tab shows
  document.querySelectorAll('a[data-bs-toggle="tab"]').forEach(btn => {
    btn.addEventListener('shown.bs.tab', recalc);
  });
});
